import { Box, Flex, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import CompleteProgressIcon from "../../../assets/progress-view/completedNew.svg";
import CompletedConnectingLine from "../../../assets/progress-view/lineCompletedNew.svg";
import ConnectingLine from "../../../assets/progress-view/lineNew.svg";
import DefaultProgressIcon from "../../../assets/progress-view/defaultNew.svg";
import FirstProgressIcon from "../../../assets/progress-view/oneNew.svg";
import FirstTrophyIcon from "../../../assets/progress-view/trophyOneNew.svg";
import GreenCompleteProgressIcon from "../../../assets/progress-view/greenCompletedNew.svg";
import LeftIcon from "../../../assets/progress-view/leftIcon.svg";
import { ProgressViewStyles } from "./ProgressViewStyles";
import RightIcon from "../../../assets/progress-view/rightIcon.svg";
import SecondProgressIcon from "../../../assets/progress-view/twoNew.svg";
import SecondTrophyIcon from "../../../assets/progress-view/trophyTwoNew.svg";
import TrophyCompletedIcon from "../../../assets/progress-view/trophyCompletedNew.svg";
import TrophyIcon from "../../../assets/progress-view/trophyNew.svg";
import EmptyProgressIcon from "../../../assets/progress-view/emptyProgressIcon.svg";
import TrophyStartedIcon from "../../../assets/progress-view/trophyStartedIcon.svg";
import { usePractice } from "../../../context/PracticeContext";
import { useRoot } from "../../../context/RootContext";
import { isNotEmptyOrNull } from "../../../utils/common-utils";
import TimerClock from "../../atoms/TimerClock";
import timeLogsDB from "../../../utils/TimeLogsDB";

const ProgressView = (props) => {
  const [mainQuestionIndex, setMainQuestionIndex] = useState(0);
  const [similarTypeQuestionCount, setSimilarTypeQuestionCount] = useState(0);
  const [totalMainQuestions, setTotalMainQuestions] = useState([]);
  const [displayStartIndex, setDisplayStartIndex] = useState(0);
  const [previousTriggered, setPreviousTriggered] = useState(false);
  const [nextTriggered, setNextTriggered] = useState(false);
  const { learningStepData, isLastQues } = usePractice();
  const [lastBasketStatus, setLastBasketStatus] = useState("");
  const [sessionStartedAt, setSessionStartedAt] = useState(0);
  const { taskType, isTutor } = useRoot();

  // Number of Progress Icon to display per breakpoint
  const displayLimit = useBreakpointValue({
    base: 3,
    sm: 3,
    md: 5,
    lg: 10,
    xl: 10,
  });
  const isMobile = useBreakpointValue({
    base: true,
    md: false,
    lg: false,
  });

  // Show/Hide Pagination
  const shouldShowPagination = useBreakpointValue({
    base: totalMainQuestions?.length > 3,
    sm: totalMainQuestions?.length > 3,
    md: totalMainQuestions?.length > 5,
    lg: totalMainQuestions?.length > 10,
    xl: totalMainQuestions?.length > 10,
  });

  //show prev/next text
  const shouldShowNextPrev = useBreakpointValue({
    base: false,
    sm: false,
    md: true,
    lg: true,
    xl: true,
  });

  // console.log("LEARNING STEP DATA, taskType", learningStepData, taskType);

  useEffect(() => {
    if (isNotEmptyOrNull(learningStepData)) {
      // During Execution
      let questionCount =
        taskType === "learnSubtopic" || taskType === "learn"
          ? learningStepData?.total_steps
          : learningStepData?.question_count;

      let last_basket_status =
        learningStepData?.current_step_eval_state?.toLowerCase();
      let current_basket_index = learningStepData?.current_step_index;
      setTotalMainQuestions(Array(questionCount).fill(null));
      const { m_index, s_index } =
        taskType !== "learnSubtopic" && taskType !== "learn"
          ? learningStepData?.visited_question_indices
          : { m_index: current_basket_index, s_index: 0 };
      setMainQuestionIndex(m_index);
      setSimilarTypeQuestionCount(
        taskType === "learnSubtopic" || taskType === "learn" ? 0 : s_index
      );
      setDisplayStartIndex(Math.floor(m_index / displayLimit) * displayLimit);
      setLastBasketStatus(last_basket_status);
    }
    isNotEmptyOrNull(learningStepData) && getStartTimeOfTimer();
  }, [learningStepData, displayLimit]);

  const getStartTimeOfTimer = async () => {
    let timeLogsData = await timeLogsDB.getTimeLogs(
      learningStepData?.journey_id
    );
    let timeLogs = timeLogsData?.timeLogs || [];
    let isWithinThreshold = timeLogsDB.isWithinTimeThreshold(
      timeLogs?.[timeLogs?.length - 1]?.updatedAt
    );
    if (isWithinThreshold) {
      setSessionStartedAt(timeLogs?.[timeLogs?.length - 1]?.sessionTime);
    }
    console.log("Time Logs Data", timeLogsData);
  };

  // Progress Icon Size for active and non-active part
  const getProgressIconSize = (index) => {
    let isCurrentIndex = index === mainQuestionIndex;

    // for execution flow
    if (isCurrentIndex && similarTypeQuestionCount === 0) {
      return {
        width: { base: "32px", md: "36px", lg: "40px" },
        height: { base: "32px", md: "36px", lg: "40px" },
      };
    }

    if (index === mainQuestionIndex && similarTypeQuestionCount !== 0) {
      return {
        width: { base: "32px", md: "36px", lg: "40px" },
        height: { base: "32px", md: "36px", lg: "40px" },
      };
    }
    return {
      width: { base: "24px", md: "28px", lg: "32px" },
      height: { base: "24px", md: "28px", lg: "32px" },
    };
  };

  // Progress Icon based on thhe m_index and s_index values
  const getProgressIcon = (index) => {
    // For Execution case
    if (taskType === "learnSubtopic" || taskType === "learn") {
      if (index === totalMainQuestions?.length - 1) {
        if (mainQuestionIndex === totalMainQuestions?.length - 1) {
          return lastBasketStatus === "inprogress"
            ? TrophyStartedIcon
            : TrophyCompletedIcon;
        }
        return TrophyIcon;
      }
      if (index < mainQuestionIndex) {
        return GreenCompleteProgressIcon;
      }
      if (index === mainQuestionIndex) {
        return lastBasketStatus === "inprogress"
          ? EmptyProgressIcon
          : CompleteProgressIcon;
      }
    } else {
      if (index < mainQuestionIndex - 1) {
        return GreenCompleteProgressIcon;
      }
      if (index === mainQuestionIndex - 1) {
        if (similarTypeQuestionCount === 0 && !isLastQues) {
          return CompleteProgressIcon;
        } else {
          return GreenCompleteProgressIcon;
        }
      }
      if (index === mainQuestionIndex) {
        if (index === totalMainQuestions?.length - 1) {
          if (isLastQues) {
            return TrophyCompletedIcon;
          }
          if (similarTypeQuestionCount === 0) return TrophyIcon;
          if (similarTypeQuestionCount === 1) return FirstTrophyIcon;
          if (similarTypeQuestionCount >= 2 && !isLastQues)
            return SecondTrophyIcon;
          return TrophyCompletedIcon;
        }
        if (similarTypeQuestionCount === 0) return EmptyProgressIcon;
        if (similarTypeQuestionCount === 1) return FirstProgressIcon;
        if (similarTypeQuestionCount >= 2) return SecondProgressIcon;
      }
      if (index === totalMainQuestions?.length - 1) {
        return TrophyIcon;
      }
    }

    return DefaultProgressIcon;
  };

  // Function to get the connecting line
  const getConnectingLine = (index) => {
    //execution flow
    if (taskType === "learnSubtopic" || taskType === "learn") {
      if (index < mainQuestionIndex) {
        return CompletedConnectingLine;
      }
      return ConnectingLine;
    } else {
      if (index < mainQuestionIndex - 1) {
        return CompletedConnectingLine;
      }
      if (
        index === mainQuestionIndex - 1 &&
        similarTypeQuestionCount === 0 &&
        !isLastQues
      ) {
        return ConnectingLine;
      }
      if (
        index === mainQuestionIndex - 1 &&
        similarTypeQuestionCount === 0 &&
        isLastQues
      ) {
        return CompletedConnectingLine;
      }
      if (index === mainQuestionIndex - 1 && similarTypeQuestionCount !== 0) {
        return CompletedConnectingLine;
      } else {
        return ConnectingLine;
      }
    }
  };

  const handlePrevious = () => {
    setPreviousTriggered(true);
    setDisplayStartIndex(Math.max(0, displayStartIndex - displayLimit));
  };

  const handleNext = () => {
    setNextTriggered(true);
    setDisplayStartIndex(
      Math.min(
        totalMainQuestions?.length - displayLimit,
        displayStartIndex + displayLimit
      )
    );
  };

  useEffect(() => {
    if (
      !previousTriggered &&
      displayStartIndex >= displayLimit &&
      !props?.isReviewScreen
    ) {
      setDisplayStartIndex(
        Math.min(totalMainQuestions?.length - displayLimit, displayStartIndex)
      );
    }
    setPreviousTriggered(false);
    setNextTriggered(false);
  }, [
    displayStartIndex,
    mainQuestionIndex,
    similarTypeQuestionCount,
    displayLimit,
  ]);

  const displayedQuestions = totalMainQuestions.slice(
    displayStartIndex,
    displayStartIndex + displayLimit
  );

  if (
    ((taskType === "learnSubtopic" || taskType === "learn") &&
      (!isNotEmptyOrNull(learningStepData?.total_steps) ||
        !isNotEmptyOrNull(learningStepData?.current_step_index))) ||
    (taskType !== "learnSubtopic" &&
      taskType !== "learn" &&
      (!isNotEmptyOrNull(learningStepData?.question_count) ||
        !isNotEmptyOrNull(learningStepData?.visited_question_indices)))
  ) {
    return null;
  }

  return (
    <Flex sx={ProgressViewStyles().globalContainer}>
      <Flex
        sx={
          props?.isReviewScreen
            ? ProgressViewStyles().mainContainerReview
            : ProgressViewStyles().mainContainerExecution
        }
      >
        <Flex sx={ProgressViewStyles().progressContainer}>
          {shouldShowPagination && displayStartIndex !== 0 && (
            <Flex
              onClick={displayStartIndex === 0 ? undefined : handlePrevious}
              sx={
                displayStartIndex === 0
                  ? ProgressViewStyles().leftPaginationNotAllowed
                  : ProgressViewStyles().leftPaginationAllowed
              }
            >
              <Image src={LeftIcon} sx={ProgressViewStyles().paginationIcons} />
              {shouldShowNextPrev && (
                <Box sx={ProgressViewStyles().previousText}>Previous</Box>
              )}
              <Box
                sx={
                  displayStartIndex === 0
                    ? ProgressViewStyles().previousCountTranslucent
                    : ProgressViewStyles().previouseCountOpaque
                }
              >
                {displayStartIndex}
              </Box>
            </Flex>
          )}

          {/* Progress Icons */}
          <Flex sx={ProgressViewStyles().progressIconsContainer}>
            {displayedQuestions.map((_, index) => {
              const actualIndex = shouldShowPagination
                ? displayStartIndex + index
                : index;
              const { width, height } = getProgressIconSize(actualIndex);

              return (
                <Box
                  key={actualIndex}
                  sx={
                    index < displayedQuestions.length - 1
                      ? ProgressViewStyles().progressIconIndividualContainerLess
                      : ProgressViewStyles().progressIconIndividualContainerMore
                  }
                  cursor={props?.isReviewScreen ? "pointer" : "default"}
                >
                  {/* Progress Icon */}
                  <Box sx={ProgressViewStyles(width, height).progressIconBox}>
                    <Image
                      src={getProgressIcon(actualIndex)}
                      sx={ProgressViewStyles().progressIcon}
                    />
                  </Box>

                  {/* Connecting Line */}
                  {index < displayedQuestions.length - 1 && (
                    <Box sx={ProgressViewStyles().connectingLineBox}>
                      <Image
                        src={getConnectingLine(actualIndex)}
                        sx={ProgressViewStyles().connectingLine}
                      />
                    </Box>
                  )}
                </Box>
              );
            })}
          </Flex>

          {/* Next Navigation */}
          {shouldShowPagination &&
            displayStartIndex + displayLimit < totalMainQuestions.length && (
              <Flex
                onClick={
                  displayStartIndex + displayLimit >= totalMainQuestions.length
                    ? undefined
                    : handleNext
                }
                sx={
                  displayStartIndex + displayLimit >= totalMainQuestions.length
                    ? ProgressViewStyles().rightPaginationNotAllowed
                    : ProgressViewStyles().rightPaginationAllowed
                }
              >
                <Box
                  sx={
                    displayStartIndex + displayLimit >=
                    totalMainQuestions.length
                      ? ProgressViewStyles().nextCountTranslucent
                      : ProgressViewStyles().nextCountOpaque
                  }
                >
                  {displayStartIndex + displayLimit > totalMainQuestions.length
                    ? 0
                    : totalMainQuestions.length -
                      (displayStartIndex + displayLimit)}
                </Box>
                {shouldShowNextPrev && (
                  <Box sx={ProgressViewStyles().nextText}>Next</Box>
                )}
                <Image
                  sx={ProgressViewStyles().paginationIcons}
                  src={RightIcon}
                />
              </Flex>
            )}
        </Flex>
        {!isTutor && (
          <Box
            display="flex"
            flex={isMobile && 0.2}
            alignItems="center"
            justifyContent={"center"}
          >
            <TimerClock
              startTimeInSeconds={sessionStartedAt}
              isMobile={isMobile}
              autoStart={true}
            />
          </Box>
        )}
      </Flex>
    </Flex>
  );
};

export default ProgressView;
